import { render, staticRenderFns } from "./AddOns.vue?vue&type=template&id=c8cf9110"
import script from "./AddOns.vue?vue&type=script&lang=ts"
export * from "./AddOns.vue?vue&type=script&lang=ts"
import style0 from "./AddOns.vue?vue&type=style&index=0&id=c8cf9110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports